import {
    LEAVE_CAPS,
    CONFIRMED_STATUSES,
    PROBATION_STATUSES,
} from '../constants/leaveConstants';

/**
 * Returns the caps object for the given employment status, or null if the
 * status is unrecognised (in which case the UI should fall back to read-only).
 */
export const getLeaveCaps = (employmentStatus) => {
    if (CONFIRMED_STATUSES.includes(employmentStatus)) return LEAVE_CAPS.CONFIRMED;
    if (PROBATION_STATUSES.includes(employmentStatus)) return LEAVE_CAPS.PROBATION;
    return null;
};

export const isProbation = (employmentStatus) =>
    PROBATION_STATUSES.includes(employmentStatus);

const FIELD_LABEL = {
    sick: 'Sick leave',
    casual: 'Casual leave',
    total: 'Total leave',
};

/**
 * Validate one field's value against the cap.
 * Returns null if OK, otherwise a user-facing error string ready for toast /
 * helperText.
 */
export const validateLeaveField = (field, rawValue, employmentStatus) => {
    if (rawValue === '' || rawValue === null || rawValue === undefined) return null;

    const value = Number(rawValue);
    if (!Number.isFinite(value)) return 'Please enter a number.';
    // Half days are allowed, so the balance must be a multiple of 0.5.
    if ((value * 2) % 1 !== 0) return 'Leave balance must be in steps of 0.5 days.';
    if (value < 0) return 'Leave balance cannot be negative.';

    const caps = getLeaveCaps(employmentStatus);
    if (!caps) return null;

    if (
        isProbation(employmentStatus) &&
        (field === 'sick_leaves' || field === 'casual_leaves')
    ) {
        if (value !== 0) return 'Not applicable during probation.';
        return null;
    }

    const fieldKey = field.replace('_leaves', '');
    const cap = caps[fieldKey];
    if (cap == null) return null;
    if (value > cap) {
        const label = FIELD_LABEL[fieldKey] || 'Leave';
        return `${label} cannot exceed ${cap} days.`;
    }
    return null;
};

/**
 * Validate the whole form. Returns a { field: errorString } map; an empty
 * object means the form is valid.
 */
export const validateLeaveForm = ({
    employmentStatus,
    total_leaves,
    sick_leaves,
    casual_leaves,
}) => {
    const errors = {};
    const s = validateLeaveField('sick_leaves', sick_leaves, employmentStatus);
    const c = validateLeaveField('casual_leaves', casual_leaves, employmentStatus);
    const t = validateLeaveField('total_leaves', total_leaves, employmentStatus);
    if (s) errors.sick_leaves = s;
    if (c) errors.casual_leaves = c;
    if (t) errors.total_leaves = t;
    return errors;
};
